import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDate from "../../../modules/SimpleDate";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import {
  DDL_IS_NON_HOTLINE_FILTER,
  INITIAL_FILTER,
  TAB_CODE,
  TIPE_PENGAJUAN_CONSTANT,
} from "./constant";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleMonthYearPicker from "../../../modules/SimpleMonthYearPicker";
import { DateObject } from "react-multi-date-picker";
import { fetchDataAsync } from "../../../Services/Utils";
import Api from "../../../Services/Api";
import { HttpStatus } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";

class ManagementClaimFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: INITIAL_FILTER,
      kodeVariantOptions: [],
      kodeWarnaOptions: [],
      provinceOptions: [],
      kabkotOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
      zipCodeOptions: [],
      zipCodeRaw: [],
    };
  }

  componentDidMount() {
    this.loadDDL();
    if (this.props.submitedFilter) {
      this.setState({
        filterData: this.props.submitedFilter,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const currFilter = this.state.filterData;
    const prevFilter = prevState.filterData;
    if (
      currFilter?.kodeVarian?.value &&
      currFilter?.kodeVarian?.value !== prevFilter?.kodeVarian?.value
    ) {
      this.fetchDataWarna(currFilter?.kodeVarian?.value);
    }

    if (
      prevFilter?.provinsi?.value !== currFilter.provinsi?.value &&
      currFilter.provinsi?.value
    ) {
      this.fetchDataKabKot(currFilter.provinsi?.value);
    }
    if (
      prevFilter?.kabkot?.value !== currFilter.kabkot?.value &&
      currFilter.kabkot?.value
    ) {
      this.fetchDataKecamatan(currFilter.kabkot?.value);
    }
    if (
      prevFilter?.kecamatan?.value !== currFilter.kecamatan?.value &&
      currFilter.kecamatan?.value
    ) {
      this.fetchDataKelurahan(currFilter.kecamatan?.value);
    }
    if (
      (prevFilter?.kelurahan?.value !== currFilter.kelurahan?.value &&
        this.state.zipCodeRaw?.length > 0) ||
      this.state.zipCodeRaw?.length !== prevState?.zipCodeRaw?.length
    ) {
      const data = this.state.zipCodeRaw.find(
        (item) => item.id === currFilter.kelurahan?.value
      );
      this.setDataOptions(
        "zipCodeOptions",
        data ? [mapToObjectDDL(data.zipcode, data.zipcode)] : []
      );
    }
  }

  setValue = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filterData: {
        ...prev.filterData,
        [name]: value,
      },
    }));
  };

  handleReset = () => {
    this.setState({
      filterData: INITIAL_FILTER,
    });
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { filterData } = this.state;
    onSubmit(filterData);
  };

  getTahunProduksi = (yearString) => {
    if (!yearString) return null;
    const year = parseInt(yearString, 10);
    return new DateObject(new Date(year, 0, 1)); // month = 0 (January)
  };

  loadDDL = async () => {
    const { setError, onTriggerLoading, selectedCabang } = this.props;
    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
        setError: setError,
        menuName: "Management Claim",
        args: {},
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllProvince,
        setError: setError,
        menuName: "Management Claim",
        args: {},
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPartManagementClaim,
        menuName: "Management Claim",
        setError: setError,
        args: {
          kodeCabang: selectedCabang?.value,
          paramFilters: {},
        },
      }),
    ];

    onTriggerLoading();
    const res = await Promise.all(promises);
    onTriggerLoading();
    if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        kodeVariantOptions: res[0].data.data.map((item) =>
          mapToObjectDDL(item.kodeVariant, item.kodeVariant)
        ),
      }));
    }
    if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        provinceOptions: res[1].data.data.map((item) =>
          mapToObjectDDL(item.provinceName, item.id)
        ),
      }));
    }
    if (res[2].ok && res[2].data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        kodePartOptions: res[2].data.data.map((item) =>
          mapToObjectDDL(`${item.kodePart} - ${item.partName}`, item.kodePart)
        ),
      }));
    }
  };

  fetchDataWarna = async (value) => {
    const { onTriggerLoading } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam,
      setError: this.props.setError,
      menuName: "Management Claim",
      args: { paramFilters: { kodeVariant: value } },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        kodeWarnaOptions: res.data.data.map((item) =>
          mapToObjectDDL(item.kodeWarna, item.kodeWarna)
        ),
      }));
    }
  };

  fetchDataKabKot = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllCity,
      setError: this.props.setError,
      menuName: "Management Claim",
      args: id,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      this.setDataOptions(
        "kabkotOptions",
        response.data.data.map((item) =>
          mapToObjectDDL(item.kabKotName, item.kabKotId)
        )
      );
    }
  };

  fetchDataKecamatan = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan,
      setError: this.props.setError,
      menuName: "Management Claim",
      args: id,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      this.setDataOptions(
        "kecamatanOptions",
        response.data.data.map((item) =>
          mapToObjectDDL(item.kecamatanName, item.id)
        )
      );
    }
  };

  fetchDataKelurahan = async (id) => {
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan,
      setError: this.props.setError,
      menuName: "Management Claim",
      args: id,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      this.setDataOptions(
        "kelurahanOptions",
        response.data.data.map((item) =>
          mapToObjectDDL(item.kelurahanname, item.id)
        )
      );
      this.setDataOptions("zipCodeRaw", response.data.data);
    }
  };

  setDataOptions = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  handleResetLocationOptions = (name) => {
    if (name === "provinsi") {
      this.setState((prev) => ({
        ...prev,
        filterData: {
          ...prev.filterData,
          kabkot: null,
          kelurahan: null,
          kecamatan: null,
          kodePos: null,
        },
      }));

      this.setDataOptions("kabkotOptions", []);
      this.setDataOptions("kelurahanOptions", []);
      this.setDataOptions("kecamatanOptions", []);
      this.setDataOptions("zipCodeOptions", []);
      this.setDataOptions("zipCodeRaw", []);
      return;
    }

    if (name === "kabkot") {
      this.setState((prev) => ({
        ...prev,
        filterData: {
          ...prev.filterData,
          kelurahan: null,
          kecamatan: null,
          kodePos: null,
        },
      }));

      this.setDataOptions("kelurahanOptions", []);
      this.setDataOptions("kecamatanOptions", []);
      this.setDataOptions("zipCodeOptions", []);
      this.setDataOptions("zipCodeRaw", []);
      return;
    }
    if (name === "kecamatan") {
      this.setState((prev) => ({
        ...prev,
        filterData: {
          ...prev.filterData,
          kelurahan: null,
          kodePos: null,
        },
      }));

      this.setDataOptions("kelurahanOptions", []);
      this.setDataOptions("zipCodeOptions", []);
      this.setDataOptions("zipCodeRaw", []);
      return;
    }
  };

  render() {
    const { visible, onClickClose, tabCode } = this.props;
    const {
      filterData,
      kodeWarnaOptions,
      kodeVariantOptions,
      kodePartOptions,
      provinceOptions,
      kabkotOptions,
      kecamatanOptions,
      kelurahanOptions,
      zipCodeOptions,
    } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          visible={visible}
          onClickClose={onClickClose}
          title="Filter Search"
          content={
            <ModalContainer>
              <SimpleInput
                id="input_id_claim"
                name="idClaim"
                label="ID Claim"
                value={filterData.idClaim}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <div>
                <h4 className="txt-site txt-11 txt-main txt-bold">
                  Tanggal Claim
                </h4>
              </div>
              <FlexView style={{ gap: "10px" }}>
                <SimpleDate
                  id="select_date_fromDate"
                  date={filterData.startTanggalClaim}
                  onChange={(value) =>
                    this.setValue(
                      "startTanggalClaim",
                      moment(value).format("DD-MM-YYYY")
                    )
                  }
                />
                <span className="margin-top-15px">s/d</span>

                <SimpleDate
                  id="select_date_endDate"
                  date={filterData.endTanggalClaim}
                  onChange={(value) =>
                    this.setValue(
                      "endTanggalClaim",
                      moment(value).format("DD-MM-YYYY")
                    )
                  }
                />
              </FlexView>
              <SimpleInput
                id="input_nomor_claim"
                name="nomorClaim"
                label="Nomor Claim"
                value={filterData.nomorClaim}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleDDL
                id="options_tipe_pengajuan"
                box="search"
                name="tipeClaim"
                label="Tipe Pengajuan"
                value={filterData.tipeClaim}
                options={TIPE_PENGAJUAN_CONSTANT}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              {tabCode === TAB_CODE.LENGKAP && (
                <React.Fragment>
                  <SimpleInput
                    id="input_nomor_bbm_pencairan"
                    name="nomorBbmPencarian"
                    label="Nomor BBM Pencairan"
                    value={filterData.nomorBbmPencarian}
                    onChange={({ target }) =>
                      this.setValue(target.name, target.value)
                    }
                  />
                </React.Fragment>
              )}
              <SimpleDDL
                id="options_is_non_hotline"
                box="search"
                name="nonHotline"
                label="NON-HOTLINE"
                value={filterData.nonHotline}
                options={DDL_IS_NON_HOTLINE_FILTER}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleInput
                id="input_id_hotline"
                name="idHotline"
                label="ID Hotline"
                value={filterData.idHotline}
                readOnly={filterData?.nonHotline?.value ?? true}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              {tabCode === TAB_CODE.LENGKAP && (
                <React.Fragment>
                  <SimpleInput
                    id="input_nomor_bkk_bbk"
                    name="nomorPembelian"
                    label="Nomor BKK/BBK Pembelian"
                    value={filterData.nomorPembelian}
                    readOnly={!filterData?.nonHotline?.value ?? true}
                    onChange={({ target }) =>
                      this.setValue(target.name, target.value)
                    }
                  />
                </React.Fragment>)}
              <SimpleInput
                id="input_nama_pelapor"
                name="namaPelapor"
                label="Nama Pelapor"
                value={filterData.namaPelapor}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_nama_pemilik"
                name="namaPemilik"
                label="Nama Pemilik"
                value={filterData.namaPemilik}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              {tabCode === TAB_CODE.LENGKAP && (
                <React.Fragment>
                  <div>
                    <h4 className="txt-site txt-11 txt-main txt-bold">
                      Tanggal Lengkap
                    </h4>
                  </div>
                  <FlexView style={{ gap: "10px" }}>
                    <SimpleDate
                      id="select_date_lengkap"
                      date={filterData.startTanggalLengkap}
                      onChange={(value) =>
                        this.setValue(
                          "startTanggalLengkap",
                          moment(value).format("DD-MM-YYYY")
                        )
                      }
                    />
                    <span className="margin-top-15px">s/d</span>
                    <div>
                      <SimpleDate
                        id="select_date_end_lengkap"
                        date={filterData.endTanggalLengkap}
                        onChange={(value) =>
                          this.setValue(
                            "endTanggalLengkap",
                            moment(value).format("DD-MM-YYYY")
                          )
                        }
                      />
                    </div>
                  </FlexView>
                </React.Fragment>)}
              <h4 className="txt-site txt-11 txt-main txt-bold">
                Tahun Produksi
              </h4>
              <FlexView style={{ gap: "10px" }}>
                <SimpleMonthYearPicker
                  id="select_year_start_lengkap"
                  placeholder="YYYY"
                  value={this.getTahunProduksi(
                    filterData.startTahunProduksiUnit
                  )}
                  onlyYearPicker
                  onChange={(value) =>
                    this.setValue(
                      "startTahunProduksiUnit",
                      value?.format("YYYY")
                    )
                  }
                />
                <span className="margin-top-15px">s/d</span>
                <SimpleMonthYearPicker
                  id="select_year_end_lengkap"
                  placeholder="YYYY"
                  onlyYearPicker
                  value={this.getTahunProduksi(
                    filterData.endTahunProduksiUnit
                  )}
                  onChange={(value) =>
                    this.setValue(
                      "endTahunProduksiUnit",
                      value?.format("YYYY")
                    )
                  }
                />
              </FlexView>
              <SimpleInput
                id="input_nomor_rangka"
                name="nomorRangka"
                label="Nomor Rangka"
                value={filterData.nomorRangka}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_nomor_mesin"
                name="nomorMesin"
                label="Nomor Mesin"
                value={filterData.nomorMesin}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleDDL
                id="options_kode_varian"
                box="search"
                name="kodeVarian"
                label="Kode Varian"
                value={filterData.kodeVarian}
                options={kodeVariantOptions}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="options_kode_warna"
                box="search"
                name="kodeWarna"
                label="Kode Warna"
                value={filterData.kodeWarna}
                options={kodeWarnaOptions}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleInput
                id="input_nik"
                name="nik"
                label="NIK"
                value={filterData.nik}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_alamat"
                name="alamat"
                label="Alamat"
                value={filterData.alamat}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />

              <SimpleDDL
                id="options_provinsi"
                box="search"
                name="provinsi"
                label="Provinsi"
                value={filterData.provinsi}
                options={provinceOptions}
                onChange={(value, { name }) => {
                  this.handleResetLocationOptions("provinsi");
                  this.setValue(name, value);
                }}
              />
              <SimpleDDL
                id="options_kabkot"
                box="search"
                name="kabkot"
                label="Kabupaten/Kota"
                value={filterData.kabkot}
                options={kabkotOptions}
                onChange={(value, { name }) => {
                  this.setValue(name, value);
                  this.handleResetLocationOptions("kabkot");
                }}
              />
              <SimpleDDL
                id="options_kecamatan"
                box="search"
                name="kecamatan"
                label="Kecamatan"
                value={filterData.kecamatan}
                options={kecamatanOptions}
                onChange={(value, { name }) => {
                  this.setValue(name, value);
                  this.handleResetLocationOptions("kecamatan");
                }}
              />
              <SimpleDDL
                id="options_kelurahan"
                box="search"
                name="kelurahan"
                label="Kelurahan"
                value={filterData.kelurahan}
                options={kelurahanOptions}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="options_kode_pos"
                box="search"
                name="kodePos"
                label="Kode Pos"
                value={filterData.kodePos}
                options={zipCodeOptions}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleInput
                id="input_memberId"
                name="memberId"
                label="Member ID"
                value={filterData.memberId}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_nomorHp1"
                name="nomorHp1"
                label="Nomor HP 1"
                value={filterData.nomorHp1}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_nomorHp2"
                name="nomorHp2"
                label="Nomor HP 2"
                value={filterData.nomorHp2}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleDDL
                id="options_kode_part"
                box="search"
                name="kodePart"
                label="Kode Part"
                value={filterData.kodePart}
                options={kodePartOptions}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <FlexView hAlignContent="right" style={{ gap: "25px" }}>
                <SimpleButton
                  id="btn_reset"
                  text="Hapus"
                  onClick={this.handleReset}
                />
                <SimpleButton
                  id="btn_reset"
                  text="Terapkan"
                  onClick={this.handleSubmit}
                />
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default ManagementClaimFilter;
